import React, { useMemo } from 'react';
import { getCompanyNavigationInfo, getCompanyPageRoute, getCompanyPageName } from '../../../utils/companyNavigation';

interface CompanySubNavigationProps {
    currentRoute: string;
    onNavigate: (route: string) => void;
    isAdmin?: boolean;
}

const CompanySubNavigation: React.FC<CompanySubNavigationProps> = ({
    currentRoute,
    onNavigate,
    isAdmin = false
}) => {
    const navInfo = useMemo(() => getCompanyNavigationInfo(currentRoute), [currentRoute]);

    // Hide navigation for non-admin users
    if (!isAdmin) {
        return null;
    }

    if (!navInfo) {
        return null;
    }

    const { previousPage, nextPage, baseRoute } = navInfo;

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', width: '100%', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                {previousPage ? (
                    <button
                        onClick={() => onNavigate(getCompanyPageRoute(baseRoute, previousPage))}
                        style={{
                            padding: '6px 12px',
                            border: '1px solid #e5e7eb',
                            borderRadius: '6px',
                            backgroundColor: 'white',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            fontSize: '13px',
                            color: '#374151',
                            fontWeight: 500,
                            transition: 'all 0.2s'
                        }}
                    >
                        ← {getCompanyPageName(previousPage)}
                    </button>
                ) : (
                    <button
                        onClick={() => onNavigate('/dashboard/customers')}
                        style={{
                            padding: '6px 12px',
                            border: '1px solid #e5e7eb',
                            borderRadius: '6px',
                            backgroundColor: 'white',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            fontSize: '13px',
                            color: '#374151',
                            fontWeight: 500,
                            transition: 'all 0.2s'
                        }}
                    >
                        ← Back to Customer List
                    </button>
                )}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                {nextPage && (
                    <button
                        onClick={() => onNavigate(getCompanyPageRoute(baseRoute, nextPage))}
                        style={{
                            padding: '6px 12px',
                            border: '1px solid #e5e7eb',
                            borderRadius: '6px',
                            backgroundColor: 'white',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            fontSize: '13px',
                            color: '#374151',
                            fontWeight: 500,
                            transition: 'all 0.2s'
                        }}
                    >
                        {getCompanyPageName(nextPage)} →
                    </button>
                )}
            </div>
        </div>
    );
};

export default CompanySubNavigation;
